module.exports = __webpack_public_path__ + "static/LehrstelleEntwicklerDigitalesBusinessEFZ2025-0e7f9d35e5635a09d7349a6537ebb03e.pdf";